import { render } from "./mobileSearch.vue?vue&type=template&id=1c775c98&scoped=true&ts=true"
import script from "./mobileSearch.vue?vue&type=script&lang=ts"
export * from "./mobileSearch.vue?vue&type=script&lang=ts"

import "./mobileSearch.vue?vue&type=style&index=0&id=1c775c98&lang=scss&scoped=true"
import "./mobileSearch.vue?vue&type=style&index=1&id=1c775c98&lang=css"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c775c98"]])

export default __exports__